package com.neurobs.ccabserver.translation.components.translationreplacement.components

import com.neurobs.ccabserver.translation.states.TranslationSubSearchStateGenerator
import com.neurobs.react.semanticui.{UiButtonFactory, UiInputFactory}
import org.scalajs.dom
import org.scalajs.dom.console
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.useEffect
import slinky.core.facade.{React, ReactElement}
import slinky.web.html._

@react
object SubPhraseSearch {
  case class Props(translatorId: Long, enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    val translationSubSearchState = TranslationSubSearchStateGenerator.accessState
    val textInputRef = React.createRef[dom.html.Input]

    useEffect(() => {
      if (textInputRef.current != null) {
        textInputRef.current.value = translationSubSearchState.subPhraseState.value
      }
    }, Vector(translationSubSearchState.subPhraseState.value))

    def currentTextInput = {
      if (textInputRef.current == null) None
      else {
        val replacementText = textInputRef.current.value
        if (replacementText.length >= translationSubSearchState.minReplacementLength) Some(replacementText) else None
      }
    }

    def handleSearchClick: () => Unit = () => currentTextInput.map(translationSubSearchState.searchTranslations(props.translatorId, _))

    def InputElement() = UiInputFactory.TextInput("Translation subtext", textInputRef)
    def ButtonElement() = UiButtonFactory.Button("Search", handleSearchClick)

    props.enclosingElement(
      Seq(
        InputElement(),
        ButtonElement()
      )
    )
  }
}
